import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "@services/api";

export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async () => {
    const { data } = await api.get("/auth/me");
    return data?.data ?? data;
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    companyName: "",
    userName: "",
    isSuperadmin: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
      const user = action.payload;
      state.companyName = user?.company?.name || "";
      // `users.name` no banco guarda só o primeiro nome — o nome completo
      // (nome + sobrenome informados no cadastro) vem em `fullName`, montado
      // pelo backend a partir do user_profiles (ver auth.service.ts no back).
      state.userName = user?.fullName || user?.name || user?.email || "";
      state.isSuperadmin = user?.is_superadmin === true;
    });
  },
});

export const selectCompanyName = (state) => state.auth.companyName;
export const selectUserName = (state) => state.auth.userName;
export const selectIsSuperadmin = (state) => state.auth.isSuperadmin;
export default authSlice.reducer;
